/**
 * Returns the size of the given contents string in bytes using UTF-8 encoding.
 */
export function getFileSizeBytes(contents: string | null): number {
  if (contents == null) return 0;
  return new TextEncoder().encode(contents).length;
}
